<template>
	<main>
		<div class="container">
			<div class="scroll" v-if="!loading">
				<h1 class="page-title">{{pageData.title}}</h1>
				<component :is="component.type" :data="component" v-for="(component, index) in widgets" :key="index"></component>
				<div class="rate">
					<h2 class="date">{{formatedDate}}</h2>
					<div class="widget rate" v-for="cat in symptomCategories" :key="cat">
						<div class="category-name">{{cat}}</div>
						<div class="symptom" v-for="symptom in symptomsByCat(cat)" :key="symptom.id">
							<div class="name">{{symptom.symptom}}</div>
								<span class="gdas-menu-left"><input type="range" name="gdas-range" class="gdas-range" min="0" max="4" :val="symptom.rating" onchange="this.setAttribute('val', this.value);" v-model="symptom.rating"></span>
							</div>
						</div>
						<div class="h-align-center mt-5 mb-5">
							<button class="btn icon" @click="symptomsSave()">
								<svg width="24" height="24">
									<g clip-path="url(#clip_0)">
										<path fill="rgb(255,255,255)" stroke="none" transform="translate(0.0119629 0.012085)" d="M4.76059 12.5947L9.86404 17.6981L18.9396 8.64983L17.1745 6.88475L9.86415 14.1681L6.52567 10.8296L4.76059 12.5947ZM12.4564 0.01588L12.4567 0.0158942L12.4564 0.01588Z" fill-rule="evenodd"/>
									</g>
								</svg>
								<span>Save</span>
							</button>
					</div>
				</div>
			</div>
			<div class="loading" v-if="loading"><img src="/img/loading.gif"></div>
		</div>
	</main>
</template>

<script>
import Vue from "vue"
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
import moment from 'moment'

Vue.use(CxltToastr, moment)

//importing widgets
import textcontent from '../../components/widgets/text'

export default {
	components: {
		textcontent
	},
	props:['id','date', 'type'],
	name: 'Rate',
	computed: { // setting list of widgets
		widgets() {
			return this.components
		},
		formatedDate() {
			return moment(this.date).format("MMMM Do, YYYY")
		}
	},
	data() {
		return {
			ps:null,
			pageData:[],
			components:[],
			comp:[],
			profile: this.$route.params.id,
			symptoms:[],
			symptomCategories:[],
			lang: localStorage.lang ? localStorage.lang  : 'en',
			loading:true
		}
	},
	mounted: function() {
		this.getPagedata()
	},
	methods: {
		getPagedata: function() { // getting current page data
			this.pageData = []
			this.components = []
			this.loading = true
			this.axios.get(process.env.VUE_APP_URL+'subsection/rate_symptoms', {params:{name:'rate_symptoms', language:this.lang}})
			.then(response => {
				this.pageData = response.data
				this.prepareComponents()
				this.getSymptomsList()
			})
			// .catch(error => {
			//   console.log(error)
			//   this.$router.push({name:'prevent'})
			// })
		},
		getSymptomsList: function() { // getting symptoms and parsing symptoms categories
				this.axios.get(process.env.VUE_APP_URL+'symptoms', {params: {language:this.lang}})
				.then(response => {
					this.symptoms = response.data
					this.symptoms.map(s => {
						let exist = false
						s.rating = 0
						this.symptomCategories.map(c => {
							c == s.category ? exist = true : ''
						})
						!exist ? this.symptomCategories.push(s.category) : ''
					})
					this.type ? this.addPrefilledRates() : ''
				})
		},
		addPrefilledRates: function() {
			this.axios.get(process.env.VUE_APP_URL+'profile/'+this.id+'/symptoms', {params:{id:this.profile, date:this.$route.params.date, language:this.lang}})
				.then(response => {
						let sym = response.data.symptoms
						sym.map(s => {
							this.symptoms.map(symptom => {
								if (s.pivot.symptom_id == symptom.id) {
									symptom.rating = s.pivot.rating
									symptom.edit = true
								}
							})
						})
						this.loading = false
						this.$nextTick(() => {
							this.perfectScrollInit()
						})
				})
		},
		symptomsByCat: function(cat) { // filtering symptoms by category name
				let list = []
				this.symptoms.map(s => {
					s.category == cat ? list.push(s) : ''
				})
				return list
		},
		symptomsSave: function(){
			this.symptoms.map(s => {
				if(s.rating > 0 || s.edit) {
					let method = ''
					if(s.edit && s.rating > 0) {
						method = 'patch'
					} else if(s.edit && s.rating == 0) {
						method = 'delete'
					} else {
						method = 'post'
					}
					this.axios[method](process.env.VUE_APP_URL+'profile/'+this.profile+'/symptom/'+s.id, {date:this.$route.params.date, rating:s.rating})
				}
			})
			this.$toast.success({
				title:'Success',
				message: 'The symptoms were updated successfully',
				position: 'top right',
				timeOut: 5000
			})
			this.$router.go(-1)
		},
		prepareComponents: function(){ // making widgets array
			if(this.pageData.text_contents && this.pageData.text_contents.length > 0) {
				this.pageData.text_contents.map(a => {
					a.type = 'textcontent'
					this.components.push(a)
				})
			}
			this.$nextTick(() => {
					this.sortComponents()
			})
		},
		sortComponents: function(){ // sorting widgets by index prop
			function compare(a,b) {
				if (a.index < b.index)
					return -1;
				if (a.index > b.index)
					return 1;
				return 0;
			}

			this.components = this.components.sort(compare)

			!this.type ? this.loading = false : ''
			this.$nextTick(() => {
					this.perfectScrollInit()
			})
		},
		perfectScrollInit: function() { // perfect scroll init goes after dom update
			var container = document.querySelector('.scroll')
			if(!this.ps && container) {
				this.ps = new PerfectScrollbar(container)
			} else if(container) {
				this.ps.destroy()
				this.ps = null
				this.ps = new PerfectScrollbar(container)
				container.scrollTop = 0
			}
		}
	}
}

</script>